import { useCallback } from 'react'

import { useAuthentication } from '../../providers/auth-provider'

const useTemperatures = () => {
  const { ownUser } = useAuthentication()

  const tempFormat = ownUser?.preferences?.tempUnits ?? 'degF'
  const tempUnits = tempFormat === 'degF' ? 'F' : 'C'

  // actually not so sure about this one, do we always assume it's F?
  // do we assume the backend is giving us the right unit?
  const formatTemperature = useCallback(
    (temp: number, rounding: 'tenths' | 'integer' = 'tenths', fromUnit = 'degF', showUnit = true) => {
      let temperature = temp
      if (tempFormat === 'degC' && fromUnit === 'degF') {
        temperature = (temp - 32) * (5 / 9)
      }
      if (tempFormat === 'degF' && fromUnit === 'degC') {
        temperature = temp * (9 / 5) + 32
      }
      const roundedTemp = rounding === 'integer' ? Math.round(temperature) : Math.round(temperature * 10) / 10

      return showUnit ? `${roundedTemp}°` : roundedTemp
    },
    [tempFormat]
  )

  return { formatTemperature, tempUnits, tempFormat }
}

export default useTemperatures
